export enum RichMediaShowType {
  SHOW_TYPE_DEFAULT = 0,
  SHOW_TYPE_FULLSCREEN = 1,
  SHOW_TYPE_INLINE = 2,
  SHOW_TYPE_DRAGGABLE = 3,
}

export enum AutoPlay {
  AUTO_PLAY_DEFAULT = 0,
  AUTO_PLAY_TRUE = 1,
  AUTO_PLAY_FALSE = 2,
}

export enum LoopPlay {
  AUTO_PLAY_DEFAULT = 0,
  AUTO_PLAY_TRUE = 1,
  AUTO_PLAY_FALSE = 2,
}

export enum MediaConfigType {
  default = 'default',
  File = 'file',
  PIC = 'pic',
  VIDEO = 'video',
  AUDIO = 'audio',
  SPINE = 'spine',
  ARRAY = 'array',
}

export const ImageRatio = {
  '1:1': { width: 1, height: 1 },
  '9:16': { width: 9, height: 16 },
  '16:9': { width: 16, height: 9 },
  '4:3': { width: 4, height: 3 },
  '812:375': { width: 812, height: 375 },
  unlimited: null,
};
